var map = {
	"./fashion-express/A1/FE_A1_back_en.png": "4825",
	"./fashion-express/A1/FE_A1_front_en.png": "8407",
	"./fashion-express/A2/FE_A2_back_en.png": "63ce",
	"./fashion-express/A2/FE_A2_front_en.png": "cf78",
	"./fashion-express/A3/FE_A3_back_en.png": "524a",
	"./fashion-express/A3/FE_A3_front_en.png": "18a2",
	"./fashion-express/A4/FE_A4_back_en.png": "6cf3",
	"./fashion-express/A4/FE_A4_front_en.png": "fe96",
	"./pattern-grading/A01/PGR_A01_back_en.png": "1980",
	"./pattern-grading/A01/PGR_A01_front_en.png": "ee71",
	"./pattern-grading/A02/PGR_A02_back_en.png": "9732",
	"./pattern-grading/A02/PGR_A02_front_en.png": "5b94",
	"./pattern-grading/A03/PGR_A03_back_en.png": "8d23",
	"./pattern-grading/A03/PGR_A03_front_en.png": "0e93",
	"./pattern-grading/A04/PGR_A04_back_en.png": "a005",
	"./pattern-grading/A04/PGR_A04_front_en.png": "bd8f",
	"./pattern-grading/A05/PGR_A05_back_cross_diagonal_en.png": "d051",
	"./pattern-grading/A05/PGR_A05_back_cross_diagonal_horizontal_en.png": "5e2c",
	"./pattern-grading/A05/PGR_A05_back_cross_en.png": "72cdb",
	"./pattern-grading/A05/PGR_A05_back_cross_horizontal_en.png": "1a1a",
	"./pattern-grading/A05/PGR_A05_back_diagonal_en.png": "3d23",
	"./pattern-grading/A05/PGR_A05_back_diagonal_horizontal_en.png": "c91e",
	"./pattern-grading/A05/PGR_A05_back_en.png": "7f77",
	"./pattern-grading/A05/PGR_A05_back_horizontal_en.png": "a456",
	"./pattern-grading/A05/PGR_A05_front_cross_diagonal_en.png": "2ed3",
	"./pattern-grading/A05/PGR_A05_front_cross_diagonal_horizontal_en.png": "eeb0",
	"./pattern-grading/A05/PGR_A05_front_cross_horizontal_en.png": "67ae",
	"./pattern-grading/A05/PGR_A05_front_diagonal_en.png": "7e66",
	"./pattern-grading/A05/PGR_A05_front_diagonal_horizontal_en.png": "ad6f",
	"./pattern-grading/A05/PGR_A05_front_en.png": "3cee",
	"./pattern-grading/A05/PGR_A05_front_horizontal_en.png": "96f1",
	"./pattern_making/A01/PM_A01_back_en.png": "edcc",
	"./pattern_making/A01/PM_A01_front_en.png": "a741",
	"./pattern_making/A02/PM_A02_back_cross_diagonal_en.png": "3c438",
	"./pattern_making/A02/PM_A02_back_cross_diagonal_horizontal_en.png": "3068",
	"./pattern_making/A02/PM_A02_back_cross_en.png": "e6c8",
	"./pattern_making/A02/PM_A02_back_cross_horizontal_en.png": "276d",
	"./pattern_making/A02/PM_A02_back_diagonal_en.png": "ab35",
	"./pattern_making/A02/PM_A02_back_diagonal_horizontal_en.png": "cf41",
	"./pattern_making/A02/PM_A02_back_en.png": "74af",
	"./pattern_making/A02/PM_A02_back_horizontal_en.png": "f66f",
	"./pattern_making/A02/PM_A02_front_cross_diagonal_en.png": "adc5",
	"./pattern_making/A02/PM_A02_front_cross_diagonal_horizontal_en.png": "5b0e",
	"./pattern_making/A02/PM_A02_front_cross_en.png": "fcb6",
	"./pattern_making/A02/PM_A02_front_cross_horizontal_en.png": "32b1",
	"./pattern_making/A02/PM_A02_front_diagonal_en.png": "1ed0",
	"./pattern_making/A02/PM_A02_front_diagonal_horizontal_en.png": "98f0",
	"./pattern_making/A02/PM_A02_front_en.png": "67c2",
	"./pattern_making/A02/PM_A02_front_horizontal_en.png": "e452",
	"./pattern_making/A03/PM_A03_back_en.png": "cf26",
	"./pattern_making/A03/PM_A03_front_en.png": "1e81",
	"./pattern_making/A04/PM_A04_back_en.png": "4834",
	"./pattern_making/A04/PM_A04_front_en.png": "850e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6d0";